import React, { useEffect } from 'react';

export type CountdownProps = {
  url: string;
  seconds: number;
};

export const Countdown = ({ ...props }: CountdownProps) => {
  const { url } = props;

  useEffect(() => {
    const timerStartDownload = setTimeout(() => {
      window.location.href = url;
    }, props.seconds * 1000);

    return () => clearTimeout(timerStartDownload);
  }, [props.seconds, url]);

  return <span />;
};
